import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/templates/$id/use')({
  component: TemplateUsePage,
})

function TemplateUsePage() {
  const { id } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Use Template
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Create a new document from this template
              </p>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Template ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {id}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Template Usage Features (To be implemented)
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
                <li>Template preview with signature field positions</li>
                <li>Document title and metadata configuration</li>
                <li>Signer selection and assignment</li>
                <li>Custom field mapping and data population</li>
                <li>Create document from template action</li>
                <li>Template cloning options</li>
              </ul>
            </div>

            <div className="flex gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              <button className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                Create Document
              </button>
              <button className="px-6 py-2 bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">
                Preview Template
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
